import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Hero from "../components/Hero";
import ServicesGrid from "../components/ServicesGrid";
import HowItWorks from "../components/HowItWorks";
import SmartDiagnosis from "../components/SmartDiagnosis";
import BookingInterface from "../components/BookingInterface";
import MechanicTracker from "../components/MechanicTracker";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function Landing() {
  const [selectedServices, setSelectedServices] = useState([]);
  const [urgentMode, setUrgentMode] = useState(false);
  const location = useLocation();

  const toggleService = useCallback((id) => {
    setSelectedServices((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  }, []);

  const addService = useCallback((id) => {
    setSelectedServices((prev) => (prev.includes(id) ? prev : [...prev, id]));
  }, []);

  const handleBookNow = useCallback(() => {
    document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  // If we navigated here with a section anchor request from another page
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  }, [location.state]);

  return (
    <div className="App pb-20 md:pb-0">
      <Nav />
      <main role="main">
        <Hero onBookNow={handleBookNow} onUrgent={setUrgentMode} />
        <ServicesGrid selectedServices={selectedServices} onToggle={toggleService} />
        <HowItWorks />
        <SmartDiagnosis onAddService={addService} />
        <BookingInterface selectedServices={selectedServices} urgentMode={urgentMode} />
        <MechanicTracker />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <BottomNav />
    </div>
  );
}
